import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStatsOutlined";
import { LanguageContext } from "../context/LanguageContext";
import { useAuth } from "../hooks/AuthProvider";
import translations from "../languages/peopleCounter.json";
import "./PeopleCounter.css";

export const usePeopleCounterTranslations = () => {
  const { lang } = useContext(LanguageContext);
  return { lang, t: translations[lang] || translations.en, isRtl: ["ar", "ur"].includes(lang) };
};

export default function PeopleCounterLayout({ title, description, actions, children, requiredPermission }) {
  const { permissions } = useAuth();
  const { t, isRtl } = usePeopleCounterTranslations();
  const canViewDevices = Boolean(permissions?.view_people_counter_devices);
  const canViewStatistics = Boolean(permissions?.view_people_counter_statistics);
  const canAccessCurrentPage = requiredPermission
    ? Boolean(permissions?.[requiredPermission])
    : canViewDevices || canViewStatistics;

  if (!canAccessCurrentPage) {
    return (
      <div className="configuration devices-page people-counter-page" dir={isRtl ? "rtl" : "ltr"}>
        <div className="device-main people-counter-main people-counter-main--denied">
          <div className="people-counter-denied">
            <h2>{t.permissionDenied}</h2>
            <p>{t.noPermission}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="configuration devices-page people-counter-page" dir={isRtl ? "rtl" : "ltr"}>
      <div className="device-main people-counter-main">
        <header className="devices-header people-counter-header">
          <div className="devices-header-left people-counter-title-block">
            <h2 className="devices-title">{title}</h2>
            <p>{description}</p>
          </div>
          {actions ? <div className="people-counter-header-actions">{actions}</div> : null}
        </header>

        <nav className="people-counter-tabs" aria-label={t.navigationLabel}>
          {canViewDevices ? (
            <NavLink
              to="/people-counter/devices"
              className={({ isActive }) => `people-counter-tab${isActive ? " active" : ""}`}
            >
              <StorageOutlinedIcon fontSize="small" />
              {t.devicesTab}
            </NavLink>
          ) : null}
          {canViewStatistics ? (
            <NavLink
              to="/people-counter/statistics"
              className={({ isActive }) => `people-counter-tab${isActive ? " active" : ""}`}
            >
              <QueryStatsOutlinedIcon fontSize="small" />
              {t.statisticsTab}
            </NavLink>
          ) : null}
        </nav>

        <main className="people-counter-content">{children}</main>
      </div>
    </div>
  );
}
